export interface FunctionErrorPayload {
  message: string | null;
  /** Machine-readable cause, when the function supplies one. */
  reason: string | null;
}

/**
 * supabase-js reports any non-2xx edge function response as a generic
 * "non-2xx status code" error and keeps the real body on `context`. This reads
 * the sentence the function actually returned.
 */
export async function readFunctionError(error: unknown): Promise<FunctionErrorPayload> {
  const context = (error as { context?: Response | null } | null)?.context;
  if (context) {
    try {
      const payload = await context.clone().json() as {
        error?: string;
        message?: string;
        reason?: string | null;
      };
      return {
        message: payload.error ?? payload.message ?? null,
        reason: payload.reason ?? null,
      };
    } catch {
      // Fall back to the SDK error below.
    }
  }

  return { message: error instanceof Error ? error.message : null, reason: null };
}
